export const UNSUPPORTED_ARGUMENT_ERROR =
  '[vue-js-modal] ' + '$modal() received an unsupported argument as a first argument.'
